import React from 'react';
import ReactDOM from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const container = document.getElementById('root') as HTMLElement;

// Check of er al HTML is (prerendered door react-snap)
if (container.hasChildNodes()) {
  // Hydrate: koppel React aan bestaande HTML
  // onRecoverableError onderdrukt hydration mismatch warnings in console
  // (veroorzaakt door Cloudflare script-injectie en auth state verschil)
  ReactDOM.hydrateRoot(
    container,
    <React.StrictMode>
      <HelmetProvider>
      <App />
      </HelmetProvider>
    </React.StrictMode>,
    {
      onRecoverableError: () => {
        // Hydration mismatches zijn verwacht met react-snap + Cloudflare
        // React herstelt automatisch via client-side rendering
      }
    }
  );
} else {
  // Normale render: geen prerendered HTML aanwezig
  const root = ReactDOM.createRoot(container);
  root.render(
    <React.StrictMode>
      <HelmetProvider>

      <App />
      </HelmetProvider>
    </React.StrictMode>
  );
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();